var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 7H13.1875M0.8125 9.8125H13.1875M0.8125 12.625H13.1875M2.21875 1.375H11.7812C12.1542 1.375 12.5119 1.52316 12.7756 1.78688C13.0393 2.0506 13.1875 2.40829 13.1875 2.78125C13.1875 3.15421 13.0393 3.5119 12.7756 3.77562C12.5119 4.03934 12.1542 4.1875 11.7812 4.1875H2.21875C1.84579 4.1875 1.4881 4.03934 1.22438 3.77562C0.960658 3.5119 0.8125 3.15421 0.8125 2.78125C0.8125 2.40829 0.960658 2.0506 1.22438 1.78688C1.4881 1.52316 1.84579 1.375 2.21875 1.375V1.375Z",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.595f54529403075e0be54314a418a98c.svg";
export { ForwardRef as ReactComponent };